<template>
  <div class="filter-header">
    <v-dialog v-model="openDrop" :fullscreen="mobileView" eager persistent>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="display-16 px-1"
          :class="selections.length == 0 ? 'btn-not-selected' : 'btn-selected'"
          :disabled="filterDisabled"
          :data-cy="dataCy"
          @click="openFilter"
        >
          {{ title }}
        </v-btn>
      </template>
      <v-flex v-show="openDrop" class="drop-down" pt-4>
        <v-layout wrap px-4 class="mobile-hdr">
          <v-flex>
            <h3 class="black--text text-right display-22-16">{{ title }}</h3>
            <DropDivider :width="'100%'" />
          </v-flex>
          <v-flex>
            <h3 class="pointer text-left display-22-16" @click="closeFilter">
              X
            </h3>
            <DropDivider :width="'100%'" />
          </v-flex>
        </v-layout>
        <div id="scrollbar-box" class="scrollbar-17 ltr">
          <slot></slot>
        </div>
        <FilterFooter
          :selections="selections"
          :dataCy="dataCy"
          :multipleChoice="multipleChoice"
          :hideFooterBtn="hideFooterBtn"
          :hideSave="hideSave"
          :disable-btn="disableBtn"
          @submitFilter="submitFilter"
          @cleanSelected="cleanSelected"
          @toggleMultiple="toggleMultiple"
        />
      </v-flex>
    </v-dialog>
  </div>
</template>


<script>
import FilterHeaderBaseVue from './mixins/FilterHeaderBase.vue';
import FilterFooter from '@/components/JobsSearch/FilterFooter';
import DropDivider from '@/components/DropDownMenu/DropDivider';

export default {
  mixins: [FilterHeaderBaseVue],
  components: { FilterFooter, DropDivider },
};
</script>
